/**
 * 页面内容翻译覆盖率统计插件
 */

import Core, { utils } from '@alife/cone-arms-core';

const { checkWin } = utils;

const onPageLoad = function (core: Core, sdkCdnTag: string) {
  function doLoadPlugin() {
    setTimeout(() => {
      loadPlugin(core, sdkCdnTag);
    }, 15000);
  }
  if (document.readyState === 'complete') {
    doLoadPlugin();
  } else {
    window.addEventListener('load', doLoadPlugin);
  }
  return () => {
    window.removeEventListener('load', doLoadPlugin);
  };
};

const loadPlugin = function (core: Core, sdkCdnTag: string) {
  if (!checkWin()) {
    return;
  }
  // 采用cdn的方式加载插件
  try {
    const pluginScriptUrl =
      sdkCdnTag === 'stable'
        ? 'https://o.alicdn.com/cn-panda/page-lang-calc/index.umd.es5.production.js'
        : 'https://o.alicdn.com/cn-panda/page-lang-calc-latest/index.umd.es5.production.js';
    const script = document.createElement('script');
    script.src = pluginScriptUrl;
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.onerror = function (e) {
      core.logCustom({
        pid: 'cn-cone-arms-sdk',
        p1: 'pluginInstallError',
        c1: 'trace-translation-coverage-plugin load error',
        c2: core.getConfig()?.pid,
        c3: pluginScriptUrl,
        c4: e.toString(),
      });
    };
    document.body.appendChild(script);
  } catch (err) {
    // do nothing
  }
};

const TraceTranslationCoveragePlugin = function (core: Core, sdkCdnTag: string) {
  if (!checkWin()) {
    return;
  }
  onPageLoad(core, sdkCdnTag);
};

export default TraceTranslationCoveragePlugin;

if (checkWin()) {
  (window as any).TraceTranslationCoveragePlugin = TraceTranslationCoveragePlugin;
}
